module.exports = function getResource(label, vars = []) {
    let resources = {
        userLabelText: `Vous devez être membre ${vars[0]} pour obtenir ce produit.`,
        signIn: 'Ouvrir une session',
        or: 'ou',
        signUp: 'S’inscrire',
        learnMore: 'En savoir plus'
    };
    return resources[label];
};
